import { api } from './client';
import type {
  BannerDto,
  BannerUpsertDto,
  BlogPostDto,
  BlogPostUpsertDto,
  ContactMessageDto,
  ContactMessageStatus,
  ContactQueryDto,
  ContactReplyDto,
  FaqItemDto,
  FaqItemUpsertDto,
  MenuItemDto,
  MenuItemUpsertDto,
  NewsletterSubscriberDto,
  PageDto,
  PageUpsertDto,
  PagedRequest,
  PagedResult,
} from './types';

/* ------------------------------------------------------------------ *
 *  Icerik yonetimi — 25 uc  (/api/admin/content)
 *  sayfalar (5), blog (4), banner (4), menu (4), SSS (4),
 *  iletisim (3), bulten (1)
 * ------------------------------------------------------------------ */

export const adminContentApi = {
  /* --- Statik sayfalar --- */

  /** 1. Tum sayfalar (taslaklar dahil). */
  pages: () => api.get<PageDto[]>('/api/admin/content/pages'),

  /** 2. Sayfa detayi. */
  page: (slug: string) => api.get<PageDto>(`/api/admin/content/pages/${slug}`),

  /** 3. Sayfa olusturur. Icerik HTML'i sunucuda temizlenir. */
  createPage: (dto: PageUpsertDto) => api.post<PageDto>('/api/admin/content/pages', dto),

  /** 4. Sayfa gunceller. */
  updatePage: (id: number, dto: PageUpsertDto) =>
    api.put<PageDto>(`/api/admin/content/pages/${id}`, dto),

  /** 5. Sayfa siler. */
  deletePage: (id: number) => api.deleteCommand(`/api/admin/content/pages/${id}/delete`),

  /* --- Blog --- */

  /** 6. Blog yazilari (taslaklar dahil). */
  blogPosts: (query: PagedRequest = {}) =>
    api.get<PagedResult<BlogPostDto>>('/api/admin/content/blog', query),

  /** 6b. Tekil blog yazisi detayi. */
  blogPost: (slug: string) => api.get<BlogPostDto>(`/api/admin/content/blog/${slug}`),

  /** 7. Yazi olusturur. */
  createBlogPost: (dto: BlogPostUpsertDto) =>
    api.post<BlogPostDto>('/api/admin/content/blog', dto),

  /** 8. Yazi gunceller. */
  updateBlogPost: (id: number, dto: BlogPostUpsertDto) =>
    api.put<BlogPostDto>(`/api/admin/content/blog/${id}`, dto),

  /** 9. Yazi siler. */
  deleteBlogPost: (id: number) => api.deleteCommand(`/api/admin/content/blog/${id}/delete`),

  /* --- Banner --- */

  /** 10. Bannerlar; yerlesime gore filtrelenir. */
  banners: (placement?: string) =>
    api.get<BannerDto[]>('/api/admin/content/banners', { placement }),

  /** 11. Banner olusturur. */
  createBanner: (dto: BannerUpsertDto) => api.post<BannerDto>('/api/admin/content/banners', dto),

  /** 12. Banner gunceller. */
  updateBanner: (id: number, dto: BannerUpsertDto) =>
    api.put<BannerDto>(`/api/admin/content/banners/${id}`, dto),

  /** 13. Banner siler. */
  deleteBanner: (id: number) => api.deleteCommand(`/api/admin/content/banners/${id}/delete`),

  /* --- Menu --- */

  /** 14. Menu agaci. */
  menu: (menuKey: string) => api.get<MenuItemDto[]>(`/api/admin/content/menus/${menuKey}`),

  /** 15. Menu ogesi ekler. */
  createMenuItem: (dto: MenuItemUpsertDto) =>
    api.post<MenuItemDto>('/api/admin/content/menus', dto),

  /** 16. Menu ogesi gunceller. */
  updateMenuItem: (id: number, dto: MenuItemUpsertDto) =>
    api.put<MenuItemDto>(`/api/admin/content/menus/${id}`, dto),

  /** 17. Menu ogesi siler. */
  deleteMenuItem: (id: number) => api.deleteCommand(`/api/admin/content/menus/${id}/delete`),

  /* --- SSS --- */

  /** 18. Sikca sorulan sorular. */
  faq: (category?: string) => api.get<FaqItemDto[]>('/api/admin/content/faq', { category }),

  /** 19. Soru ekler. */
  createFaq: (dto: FaqItemUpsertDto) => api.post<FaqItemDto>('/api/admin/content/faq', dto),

  /** 20. Soru gunceller. */
  updateFaq: (id: number, dto: FaqItemUpsertDto) =>
    api.put<FaqItemDto>(`/api/admin/content/faq/${id}`, dto),

  /** 21. Soru siler. */
  deleteFaq: (id: number) => api.deleteCommand(`/api/admin/content/faq/${id}/delete`),

  /* --- Iletisim ve bulten --- */

  /** 22. Iletisim formu mesajlari. */
  contactMessages: (query: ContactQueryDto = {}) =>
    api.get<PagedResult<ContactMessageDto>>('/api/admin/content/contact-messages', query),

  /** 23. Mesaja e-posta ile yanit yazar. */
  replyToContact: (id: number, dto: ContactReplyDto) =>
    api.postCommand(`/api/admin/content/contact-messages/${id}/reply`, dto),

  /** 24. Mesajin durumunu degistirir (okundu, kapandi, spam). */
  updateContactStatus: (id: number, status: ContactMessageStatus) =>
    api.putCommand(`/api/admin/content/contact-messages/${id}/status?status=${status}`),

  /** 25. Bulten aboneleri. */
  newsletterSubscribers: (query: PagedRequest = {}) =>
    api.get<PagedResult<NewsletterSubscriberDto>>(
      '/api/admin/content/newsletter-subscribers',
      query,
    ),
};
